export default "__VITE_ASSET__C49fbivp__"